import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export function formatInTimezone(
	date: Date | string | number,
	formatStr: string,
	timezone: string,
): string {
	try {
		const dateObj =
			typeof date === 'string' || typeof date === 'number'
				? new Date(date)
				: date
		return formatInTimeZone(dateObj, timezone, formatStr)
	} catch (error) {
		console.error('Error formatting date in timezone:', error)
		return format(
			typeof date === 'string' || typeof date === 'number'
				? new Date(date)
				: date,
			formatStr,
		)
	}
}

export function getUserTimezone(): string {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone
	} catch (error) {
		console.error('Error getting user timezone:', error)
		return 'UTC'
	}
}

export function formatDateAsTimestamptz(
	year: number,
	month: number,
	day: number,
	hours: number,
	minutes: number,
	seconds: number,
	timezone: string,
): string {
	const utcMs = createTimestampInTimezone(
		year,
		month,
		day,
		hours,
		minutes,
		seconds,
		0,
		timezone,
	)
	return formatInTimeZone(new Date(utcMs), timezone, "yyyy-MM-dd'T'HH:mm:ssxxx")
}

export function createTimestampInTimezone(
	year: number,
	month: number,
	day: number,
	hours: number,
	minutes: number,
	seconds: number,
	milliseconds: number,
	timezone: string,
): number {
	try {
		const utcDate = new Date(
			Date.UTC(year, month, day, hours, minutes, seconds, milliseconds),
		)

		const formatter = new Intl.DateTimeFormat('en-US', {
			timeZone: timezone,
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			hour12: false,
		})

		const parts = formatter.formatToParts(utcDate)
		const tzYear = parseInt(
			parts.find((p) => p.type === 'year')?.value || String(year),
		)
		const tzMonth =
			parseInt(
				parts.find((p) => p.type === 'month')?.value || String(month + 1),
			) - 1
		const tzDay = parseInt(
			parts.find((p) => p.type === 'day')?.value || String(day),
		)
		const tzHour = parseInt(
			parts.find((p) => p.type === 'hour')?.value || String(hours),
		)
		const tzMinute = parseInt(
			parts.find((p) => p.type === 'minute')?.value || String(minutes),
		)
		const tzSecond = parseInt(
			parts.find((p) => p.type === 'second')?.value || String(seconds),
		)

		const offset =
			Date.UTC(
				tzYear,
				tzMonth,
				tzDay,
				tzHour,
				tzMinute,
				tzSecond,
				milliseconds,
			) - utcDate.getTime()

		return utcDate.getTime() - offset
	} catch (error) {
		console.error('Error creating timestamp in timezone:', error)
		return new Date(
			year,
			month,
			day,
			hours,
			minutes,
			seconds,
			milliseconds,
		).getTime()
	}
}
